/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RiskSettings } from './riskSettings';

export interface AssetBasedExecutionStrategySettingsDto {
  id: number;
  executionDestination: AssetBasedExecutionStrategySettingsDto.ExecutionDestinationEnum;
  spreadFromLocalMid: number;
  minSpreadFromLocalMid: number;
  globalMidBpsProtection: number;
  localSourceId?: number;
  globalSourceId?: number;
  updateOrderFrequency: number;
  maxAllowedPosition: number;
  minAllowedPosition: number;
  maxAllowedBasicTargetPosition?: number;
  minAllowedBasicTargetPosition?: number;
  riskSettings: RiskSettings;
  spotUsdSourceId?: number;
}
export namespace AssetBasedExecutionStrategySettingsDto {
  export const ExecutionDestinationEnum = {
    NoOperation: 'NO_OPERATION',
    CoinbasePerpetual: 'COINBASE_PERPETUAL',
    BybitPerpetual: 'BYBIT_PERPETUAL',
  } as const;
  export type ExecutionDestinationEnum = (typeof ExecutionDestinationEnum)[keyof typeof ExecutionDestinationEnum];
}
